class ProductGallery {
  constructor() {
    this.container = document.querySelector('.product-gallery__container');
    if (!this.container) return;

    this.slides = this.container.querySelectorAll('.product-gallery__slide');
    this.prevButton = this.container.querySelector('.product-gallery__nav--prev');
    this.nextButton = this.container.querySelector('.product-gallery__nav--next');
    this.counter = this.container.querySelector('.product-gallery__counter');
    this.currentSlide = 0;
    this.totalSlides = this.slides.length;
    this.isAnimating = false;

    this.init();
  }

  init() {
    if (this.totalSlides <= 1) return;

    // Set initial position for first slide
    gsap.set(this.slides[0], { x: 0, opacity: 1, visibility: 'visible' });
    
    // Set all other slides off-screen to the right
    gsap.set(Array.from(this.slides).slice(1), { x: '100%', opacity: 0, visibility: 'hidden' });

    this.prevButton.addEventListener('click', () => this.navigate(-1));
    this.nextButton.addEventListener('click', () => this.navigate(1));
    
    // Update counter initially
    this.updateCounter();
  }

  navigate(direction) {
    // Prevent multiple clicks during animation
    if (this.isAnimating) return;
    this.isAnimating = true;

    const currentSlide = this.slides[this.currentSlide];
    const nextIndex = (this.currentSlide + direction + this.totalSlides) % this.totalSlides;
    const nextSlide = this.slides[nextIndex];

    // Create a timeline for smooth coordinated animation
    const tl = gsap.timeline({
      onComplete: () => {
        // Clean up after animation
        currentSlide.classList.remove('is-active');
        this.isAnimating = false;
      }
    });

    // Set next slide starting position (off-screen)
    gsap.set(nextSlide, {
      x: direction > 0 ? '100%' : '-100%',
      opacity: 0,
      visibility: 'visible'
    });

    // Add next slide class
    nextSlide.classList.add('is-active');

    // Animate both slides simultaneously
    tl.to(currentSlide, {
      x: direction > 0 ? '-100%' : '100%',
      opacity: 0,
      duration: 0.6,
      ease: 'power2.inOut'
    }, 0) // Start at time 0
    .to(nextSlide, {
      x: 0,
      opacity: 1,
      duration: 0.6,
      ease: 'power2.inOut'
    }, 0); // Also start at time 0 for simultaneous animation

    // Update current slide index and counter
    this.currentSlide = nextIndex;
    this.updateCounter();
  }

  updateCounter() {
    if (this.counter) {
      this.counter.querySelector('.current').textContent = this.currentSlide + 1;
    }
  }
}

// Initialize gallery when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ProductGallery();
});
